import React from "react";
import { PROGRESS_MODE } from "../progressMode";

export default function TopProgressBar({ visible, mode, percent, label }) {
  if (!visible) return null;

  const isDeterminate = mode === PROGRESS_MODE.DETERMINATE && percent != null;

  return (
    <div
      className={`gl-top-progress gl-top-progress--${mode}`}
      aria-hidden={!visible}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={isDeterminate ? percent : undefined}
    >
      <div
        className={`gl-top-progress-bar ${isDeterminate ? "gl-top-progress-bar--determinate" : "gl-top-progress-bar--indeterminate"}`}
        style={isDeterminate ? { width: `${percent}%` } : undefined}
      />
      {isDeterminate && label ? (
        <span className="gl-top-progress-label">{label}</span>
      ) : null}
    </div>
  );
}
